import {getAPI} from "@/services/axios-api";

const state = () => ({
    categories: {
        'huître-en-ligne': {
            id: 1,
            name: 'oyster_categ',
            description: 'oyster_categ_description',
            image: "banner_categ/categorie-huitres-famille-boutrais.jpg",
            meta_image : "home/lfb_home_pres.jpg",
            // meta_image : "product_categ/ecommerce.category.content_image_1.jpg",
        },

        'crustacé-en-ligne': {
            id: 2,
            name: 'crustacean_categ',
            description: 'crustacean_categ_description',
            image: "banner_categ/categorie-crustaces-famille-boutrais.jpg",
            meta_image : "home/lfb_home_pres.jpg",
            // meta_image : "product_categ/ecommerce.category.content_image_2.jpg",

        },
        'coquillage-en-ligne': {
            id: 3,
            name: 'shellfish_categ',
            description: 'shellfish_categ_description',
            image: "banner_categ/categorie-coquillages-famille-boutrais.jpg",
            // meta_image : "product_categ/ecommerce.category.content_image_3.jpg",
            meta_image : "home/lfb_home_pres.jpg",

        },
        'epicerie-en-ligne': {
            id: 4,
            name: 'grocery_categ',
            description: 'grocery_categ_description',
            image: "banner_categ/categorie-epicerie-famille-boutrais.jpg",
            meta_image : "home/lfb_home_pres.jpg",

        },
        'vin-en-ligne': {
            id: 5,
            name: 'cellar_categ',
            description: 'cellar_categ_description',
            image: "banner_categ/categorie-cave-famille-boutrais.jpg",
            // meta_image : "product_categ/ecommerce.category.content_image_5.jpg",
            meta_image : "home/lfb_home_pres.jpg",

        },
        'coffret': {
            id: 6,
            name: 'boxes_categ',
            description: 'boxes_categ_description',
            image: "banner_categ/categorie-coffret-famille-boutrais.jpg",
            meta_image : "home/lfb_home_pres.jpg",

        },
        'accessoires': {
            id: 7,
            name: 'accessory_categ',
            description: 'accessory_categ_description',
            image: "banner_categ/categorie-accesoires-famille-boutrais.jpg",
            // meta_image : "product_categ/ecommerce.category.content_image_7.jpg",
            meta_image : "home/lfb_home_pres.jpg",

        },
        9: {
            id: 9,
            name: "how_it_work",
            description: "how_it_work_desc",
            // image: "banner_categ/categorie-commentcamarche-famille-boutrais.jpg",
            meta_image : "home/lfb_home_pres.jpg",

        },
        10: {
            id: 10,
            name: "who_are_we",
            description: "who_are_we_desc",
            image: "banner_categ/categorie-quisommesnous-famille-boutrais.jpg"
        },
        11: {
            id: 11,
            name: "saint_michel",
            description: "saint_michel_desc",
            image: "banner_categ/categorie-quisommesnous-famille-boutrais.jpg"
        },
        12: {
            id: 12,
            name: "",
            description: "",
            image: "banner_categ/categorie-quisommesnous-famille-boutrais.jpg"
        },
        13: {
            id: 13,
            name: "bannow",
            description: "bannow_desc",
            image: "banner_categ/categorie-quisommesnous-famille-boutrais.jpg"
        },
        14: {
            id: 14,
            name: "trawenagh",
            description: "trawenagh_desc",
            image: "banner_categ/categorie-quisommesnous-famille-boutrais.jpg"
        },
        15: {
            id: 15,
            name: "dundrum",
            description: "dundrum_desc",
            image: "banner_categ/categorie-quisommesnous-famille-boutrais.jpg"
        },
    },
    category: null,
});

const getters = {
    getCategoryId: function (state) {
        return state.category
    },
    getCategory: function (state) {
        return state.categories[state.category]
    },
    getCategories: function (state) {
        return state.categories
    }
};

const actions = {};

const mutations = {
    setCategory: function (state, data) {
        localStorage.setItem('c', data)
        state.category = data
    }
};

export default {
    namespaced: true, state, getters, actions, mutations,
};